import React, { useMemo, useState } from 'react';
import { InfoAlert } from 'src/components/atoms/alerts/InfoAlert';
import {
  DataBox,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from 'src/components/molecules/DataBox';
import { NewAreaGraph } from 'src/components/molecules/graphs/NewAreaGraph';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { useChartEffectTickFormatter } from 'src/hooks/useEffectFormatter';
import { INCREMENTAL_SALES_DEF } from 'src/utils/metricDefinitions';
import { useAggregationLevelContext } from '../../contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from '../../hooks/useGetDateAxisFormatter';
import { getAggregateLevelData } from '../../utils/getAggregateLevelData';
import { TimeseriesDataTableModal } from '../molecules/TimeseriesDataTableModal';

const dataKeys = {
  xAxis: 'utcEpoch',
  data: ['value'],
};

const legendProps: DataBoxLegendProps = {
  placement: 'none',
  baseLegendKeys: dataKeys.data,
  labelMap: {
    value: 'Incremental sales',
  },
};

export const IncrementalSalesBox: React.FC<DataBoxBaseProps> = ({
  ...props
}) => {
  const { decomps } = useMMDataContext();

  const [infoOpen, setInfoOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { isLoading, isError } = decomps;
  const { aggregateLevel } = useAggregationLevelContext();

  const yAxisFormatter = useChartEffectTickFormatter();

  const chartData = useMemo(() => {
    return getAggregateLevelData(decomps, aggregateLevel);
  }, [decomps, aggregateLevel]);

  const xAxisFormatter = useGetDateAxisFormatter();

  return (
    <>
      <InfoAlert
        headerText={props.title ?? ''}
        bodyText={INCREMENTAL_SALES_DEF}
        isOpen={infoOpen}
        onClose={() => setInfoOpen(false)}
      />
      <DataBox
        {...props}
        onInfoButtonClick={() => setInfoOpen(true)}
        legendProps={legendProps}
        exportEnabled
        exportButtonEnabled={false}
        setTableDataModalIsOpen={setModalIsOpen}
        hasData={chartData.length > 0}
        isError={isError}
        isLoading={isLoading}>
        <>
          <TimeseriesDataTableModal
            isOpen={modalIsOpen}
            setIsOpen={setModalIsOpen}
            yFormatter={yAxisFormatter}
            data={chartData}
            headerName={props.title ?? ''}
          />
          <NewAreaGraph
            data={chartData}
            xAxisKey={dataKeys.xAxis}
            xAxisFormatter={xAxisFormatter}
            yAxisFormatter={yAxisFormatter}
          />
        </>
      </DataBox>
    </>
  );
};
